import { Component, OnInit, Input, TemplateRef, ComponentRef } from '@angular/core';

@Component({
    selector: 'shared-dropdown-vendor-placeholder',
    template: `<div class="dropdown-vendor" [ngStyle]="styles"><ng-container *ngTemplateOutlet="tplRef || null"></ng-container></div>`,
})
export class DropdownVendorComponent implements OnInit {
    @Input() public tplRef: TemplateRef<any>;
    @Input() public styles: { [key: string]: number | string; } = { 'display': 'none' };
    @Input() public width: OLO.Components.DROPDOWN_WIDTH = 'full';

    constructor() { }

    ngOnInit(): void {
    }
}
